import {
  LOAD_ALL_USERS_REQUEST,
  LOAD_ALL_USERS_SUCCESS,
  LOAD_ALL_USERS_FAIL,
  ADD_USER_REQUEST,
  ADD_USER_SUCCESS,
  ADD_USER_RESET,
  ADD_USER_FAIL,
  UPDATE_PROFILE_REQUEST,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_RESET,
  UPDATE_PROFILE_FAIL,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_RESET,
  CHANGE_PASSWORD_FAIL,
  CLEAR_ERRORS,
} from "../constants/userConstants";

const extractUsers = (payload) => {
  if (!payload) {
    return [];
  }

  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload.users)) {
    return payload.users;
  }

  if (Array.isArray(payload.data)) {
    return payload.data;
  }

  if (payload.data && Array.isArray(payload.data.users)) {
    return payload.data.users;
  }

  if (payload.data && Array.isArray(payload.data.docs)) {
    return payload.data.docs;
  }

  if (payload.data && Array.isArray(payload.data.data)) {
    return payload.data.data;
  }

  if (payload.data && payload.data.data && Array.isArray(payload.data.data.users)) {
    return payload.data.data.users;
  }

  if (Array.isArray(payload.results)) {
    return payload.results;
  }

  if (Array.isArray(payload.payload)) {
    return payload.payload;
  }

  if (payload.payload && Array.isArray(payload.payload.users)) {
    return payload.payload.users;
  }

  return [];
};

export const usersReducer = (state = { users: [] }, action) => {
  switch (action.type) {
    case LOAD_ALL_USERS_REQUEST:
      return {
        ...state,
        user_loading: true,
        error: null,
      };

    case LOAD_ALL_USERS_SUCCESS:
      return {
        user_loading: false,
        users: extractUsers(action.payload),
      };

    case LOAD_ALL_USERS_FAIL:
      return {
        user_loading: false,
        users: [],
        error: action.payload,
      };

    case UPDATE_PROFILE_REQUEST:
      return {
        ...state,
        user_loading: true,
        errors: null,
      };

    case UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        user_loading: false,
        //isUpdated: true
        isUpdated: action.payload,
        errors: null,
      };

    case UPDATE_PROFILE_RESET:
      return {
        ...state,
        isUpdated: false,
        errors: null,
      };

    case UPDATE_PROFILE_FAIL:
      return {
        ...state,
        user_loading: false,
        error: action.payload,
        errors: action.errors,
      };

    case CHANGE_PASSWORD_REQUEST:
      return {
        ...state,
        passwordChangeLoading: true,
        passwordChanged: false,
        passwordChangeError: null,
      };

    case CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        passwordChangeLoading: false,
        passwordChanged: true,
        passwordChangeError: null,
      };

    case CHANGE_PASSWORD_RESET:
      return {
        ...state,
        passwordChangeLoading: false,
        passwordChanged: false,
        passwordChangeError: null,
      };

    case CHANGE_PASSWORD_FAIL:
      return {
        ...state,
        passwordChangeLoading: false,
        passwordChanged: false,
        passwordChangeError: action.payload,
      };

    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export const addUserReducer = (state = { user: {} }, action) => {
  switch (action.type) {
    case ADD_USER_REQUEST:
      return {
        user_loading: true,
        isAdded: false,
        errors: null,
      };

    case ADD_USER_SUCCESS:
      return {
        ...state,
        user_loading: false,
        isAdded: true,
        user: action.payload,
        errors: null,
      };

    case ADD_USER_RESET:
      return {
        ...state,
        isAdded: false,
        errors: null,
      };

    case ADD_USER_FAIL:
      return {
        ...state,
        user_loading: false,
        isAdded: false,
        user: null,
        error: action.payload,
        errors: action.errors,
      };

    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};
